import { Longhand } from "../longhand.js";
import Base from "./min-height.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/min-width}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=min-width.js.map